var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("Page Not Found")]),_c('p',[_vm._v("We could not find the page you are looking for.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }